<script lang="ts">
    import {Alert, Col, Container, Row} from "sveltestrap";
    import AngleStart from "../svg/shapes/AngleStart.svelte";
    import {appManager} from "../AppManagerStore";
    import {_} from "svelte-i18n";

    let accountApi = $appManager.IdentityApi;
    let email: string = "";
    let password: string = "";
    let state: "start" | "signedup" | "failed" | "passwordnotok" = "start";

    const urlParams = new URLSearchParams(window.location.search);
    const hasRedirect: boolean = urlParams.has("redirect");
    const redirect: string = urlParams.get("redirect") ?? `${$appManager.PublicUrl}app`;

    async function register(): Promise<void> {
        if (password.length < 6) {
            state = "passwordnotok";
            return;
        }

        if (await $appManager.Authenticator.isSignedIn()) {
            try {
                const result = await $appManager.IdentityApi.logout();
                await $appManager.Authenticator.logout();
            }
            catch{
                
            }
        }

        const signedup = await accountApi.register({
            confirmEmailUrl: `${$appManager.PublicUrl}confirmemail`,
            email: email,
            password: password,
            organizationName:  $_("user.signup.myorganization")
        });

        if (signedup) {
            // sign in with oidc, set the state to local storage.
            await $appManager.Authenticator.signinSilent();

            state = "signedup";
            if (hasRedirect) {
                window.location.href = redirect;
                return;
            }
            setTimeout(() => {
                window.location.href = redirect;
            }, 2000);
        } else {
            state = "failed";
        }
    }

    const onFocus = () => {
        if (state == "failed") state = "start";
    }
</script>

<section>
    <Container class="d-flex flex-column">
        <Row class="align-items-center justify-content-center gx-0 min-vh-100">
            <Col>
                {#if state !== "signedup"}
                    <h1 class="mb-0 fw-bold">{$_("user.signup.title")}</h1>

                    <p class="mb-6 text-muted">
                        {$_("user.signup.subtitle")}
                    </p>

                    <form class="mb-6" on:submit|preventDefault={async () => {}}>
                        <div class="form-group">
                            <label class="form-label" for="email">
                                {$_("user.signup.email")}
                            </label>
                            <input
                                type="email"
                                class="form-control"
                                id="email"
                                placeholder={$_("user.signup.emailplaceholder")}
                                bind:value={email} on:focus={onFocus} />
                        </div>

                        <div class="form-group mb-5">
                            <label class="form-label" for="password">
                                {$_("user.signup.password")}
                            </label>
                            <input
                                type="password"
                                class="form-control"
                                id="password"
                                placeholder={$_("user.signup.passwordplaceholder")}
                                bind:value={password} on:focus={onFocus} />

                                {#if state === "passwordnotok"}
                                    <Alert class="mt-2"
                                        >{$_("user.signup.passwordnotok.message")}</Alert>
                                {/if}
                        </div>

                        <button
                            class="btn w-100 btn-primary"
                            on:click={async () => await register()}>
                            {$_("user.signup.ok")}
                        </button>
                    </form>

                    {#if state == "failed"}
                        <Alert class="mt-2"
                            >{$_("user.signup.error.message")}<br />
                            {$_("user.signup.error.part1")}
                            <a href="{$appManager.PublicUrl}forgotpassword"
                                >{$_("user.signup.error.reset")}</a>.</Alert>
                    {/if}

                    <p class="mb-0 fs-sm text-muted">
                        {$_("user.signup.alreadyaccount")}
                        <a href="{$appManager.PublicUrl}signin">{$_("user.signup.signin")}</a>.
                    </p>
                {:else}
                    <h1 class="mb-0 fw-bold">{$_("user.signup.thanks")} 👍</h1>

                    <p class="mb-6 text-muted">
                        {$_("user.signup.emailconfirm")}
                    </p>

                    <p class="mb-6 text-muted">
                        {$_("user.signup.redirect.part1")} <a
                            href={redirect}>{$_("user.signup.redirect.here")}</a> 
                            {$_("user.signup.redirect.part2")}
                    </p>
                {/if}
            </Col>

            <div
                class="col-lg-7 offset-lg-1 align-self-stretch d-none d-lg-block">
                <div
                    class="h-100 w-cover bg-cover"
                    style="background-image: url(/img/covers/cover-city-traffic.png);" />

                <div class="shape shape-start shape-fluid-y text-white">
                    <AngleStart />
                </div>
            </div>
        </Row>
    </Container>
</section>
